import { render } from "./ContentUnit.vue?vue&type=template&id=86a530ac"
import script from "./ContentUnit.vue?vue&type=script&lang=js"
export * from "./ContentUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/help/ContentUnit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86a530ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86a530ac', __exports__)) {
    api.reload('86a530ac', __exports__)
  }
  
  module.hot.accept("./ContentUnit.vue?vue&type=template&id=86a530ac", () => {
    api.rerender('86a530ac', render)
  })

}


export default __exports__